<template lang="pug">
#misc
  img.z-index.misc-mask(
    height='226'
    :src="require(`@/assets/images/misc/misc-mask-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)"
  )

  v-img.misc-tree(v-if="picture == 0" src="@/assets/images/misc/tree.png")
  v-img.misc-tree(v-if="picture == 1" src="@/assets/images/misc/tree-3.png")
  v-img.misc-tree(v-if="picture == 2" src="@/assets/images/misc/tree-4.png")

  div
    .page-title.text-center.px-5
      h2.text-xl.font-weight-semibold.text--primary.d-flex.align-center.justify-center

        span.mr-2
          template(v-if="!busy && !ok")
            v-icon(color='warning') {{ icons.mdiAlert }}

        span {{ title }}

      p.font-weight-medium.text--primary.d-flex.align-center.justify-center
        | {{ message }}

      p.text-sm.font-weight-thin(
        v-for="(detail,index) in details"
        :key="`detail-${index}`"
      )
        | {{ detail }}

      //- ACTIONS...

      //- redirecionamento...
      v-btn.mb-4(
        v-if="previousRoute"
        :to="$to(previousRoute)"
        color="primary"
      )
        v-icon(left) mdi-arrow-left-circle
        | Voltar

      v-btn.mb-4.ml-4(
        v-if="$route.params.eref !== 'Index.Workspace'"
        :to="$to('Index.Workspace')"
        color="primary"
      )
        v-icon(left) mdi-home
        | Início

      template
        v-btn.mb-4.ml-4(
          v-if="forbidden"
          :to="$to('Index.Login')"
          color="accent"
        )
          v-icon(left) mdi-login-variant
          | Login

        v-btn.mb-4.ml-4(
          v-if="!ok"
          @click="$emit('refresh')"
          :loading="busy"
          :disabled="busy"
        )
          v-icon(left) mdi-refresh
          | Tentar Novamente

</template>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/misc.scss';

.z-index {
  z-index: -1;
};
</style>

<script>
import { mdiAlert, mdiInformation } from '@mdi/js'

export default {
  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,
    busy: Boolean,
    previousRoute: Object, // {Keep.Paper.Design.Link}
  },

  data: () => ({
    icons: {
      mdiAlert,
      mdiInformation,
    },
  }),

  computed: {
    picture () {
      // Retorna um índice para escolha da imagem de apoio exibida entre 3 possíveis.
      return Math.floor(Math.random() * 3)
    },

    ok () {
      return !!this.entity.ok
    },

    code () {
      return this.entity.code
    },

    forbidden () {
      return this.code === 401
    },

    title () {
      if (this.ok) return 'Situação'
      return this.busy ? 'Aguarde...' : 'Oops... Algo não deu certo!'
    },

    message () {
      const { message, blueprint } = this.entity

      if (message) return message
      if (this.busy) return "Carregando a página..."
      if (!blueprint) return 'Página não encontrada'

      const { see, eref, name } = blueprint
      const target = see || eref || name

      return target
        ? 'Página não reconhecida'
        : 'Página não suportada'
    },

    details () {
      const { details, blueprint } = this.entity

      if (details) return details
      if (this.ok) return []

      const { see, eref, name } = blueprint || {}
      const target = see || eref || name

      if (target) return [`A página requisitada é de um tipo não suportado por esta versão do aplicativo: ${target}`]
      if (this.busy) return []
      return [ 'Não foi possível abrir a página que você está procurando.' ]
    },
  },

  methods: {
  },
}
</script>
